import React, { useState } from 'react';
import { Card, Tabs, Table, Tag, Button, Progress, Row, Col, Statistic, Badge, Space, message } from 'antd';
import { PlusOutlined, ThunderboltOutlined, GlobalOutlined } from '@ant-design/icons';

const packages = [
  { key: '1', name: '日包10MB', type: '国内', price: '0.50', duration: '1天', traffic: '10MB', status: 'active', count: 12400 },
  { key: '2', name: '月包1GB', type: '国内', price: '6.00', duration: '30天', traffic: '1GB', status: 'active', count: 28600 },
  { key: '3', name: '月包5GB', type: '国内', price: '20.00', duration: '30天', traffic: '5GB', status: 'active', count: 8900 },
  { key: '4', name: '月包10GB', type: '国内', price: '35.00', duration: '30天', traffic: '10GB', status: 'active', count: 3200 },
  { key: '5', name: '年包50GB', type: '国内', price: '180.00', duration: '365天', traffic: '50GB', status: 'active', count: 1500 },
  { key: '6', name: '北美月包1GB', type: '海外-北美', price: '45.00', duration: '30天', traffic: '1GB', status: 'active', count: 620 },
  { key: '7', name: '欧洲月包1GB', type: '海外-欧洲', price: '42.00', duration: '30天', traffic: '1GB', status: 'active', count: 480 },
  { key: '8', name: '东南亚月包2GB', type: '海外-东南亚', price: '38.00', duration: '30天', traffic: '2GB', status: 'active', count: 750 },
  { key: '9', name: '全球通月包500MB', type: '全球', price: '68.00', duration: '30天', traffic: '500MB', status: 'active', count: 320 },
];

const pools = [
  { key: '1', name: '全球共享流量池A', client: '深圳割草机科技', total: 100, used: 78.4, cards: 1200, status: 'warning' },
  { key: '2', name: '华南区域流量池', client: '广州CPE公司', total: 50, used: 32.1, cards: 860, status: 'normal' },
  { key: '3', name: '海外VIP流量池', client: '北京VR体验馆', total: 200, used: 156.8, cards: 300, status: 'danger' },
  { key: '4', name: '企业共享池-安防', client: '上海安防系统', total: 80, used: 45.2, cards: 540, status: 'normal' },
];

const PackagePool: React.FC = () => {
  const items = [
    {
      key: 'packages',
      label: '套餐管理',
      children: (
        <div>
          <div style={{ marginBottom: 12, display: 'flex', justifyContent: 'flex-end' }}>
            <Button type="primary" icon={<PlusOutlined />}>新建套餐</Button>
          </div>
          <Table
            dataSource={packages}
            size="small"
            pagination={{ pageSize: 10 }}
            columns={[
              { title: '套餐名称', dataIndex: 'name', key: 'name', render: v => <strong>{v}</strong> },
              {
                title: '类型', dataIndex: 'type', key: 'type',
                render: v => <Tag color={v === '国内' ? 'blue' : v.includes('全球') ? 'gold' : 'green'} icon={v !== '国内' ? <GlobalOutlined /> : undefined}>{v}</Tag>
              },
              { title: '价格', dataIndex: 'price', key: 'price', render: v => `¥${v}` },
              { title: '时长', dataIndex: 'duration', key: 'duration' },
              { title: '流量', dataIndex: 'traffic', key: 'traffic' },
              { title: '在用卡数', dataIndex: 'count', key: 'count', render: v => v.toLocaleString() },
              {
                title: '状态', dataIndex: 'status', key: 'status',
                render: () => <Badge status="success" text="启用" />
              },
              {
                title: '操作', key: 'action',
                render: () => (
                  <Space>
                    <Button size="small">编辑</Button>
                    <Button size="small" danger>停用</Button>
                  </Space>
                )
              },
            ]}
          />
        </div>
      )
    },
    {
      key: 'pools',
      label: '流量池管理',
      children: (
        <div>
          <div style={{ marginBottom: 12, display: 'flex', justifyContent: 'flex-end' }}>
            <Button type="primary" icon={<PlusOutlined />}>创建流量池</Button>
          </div>
          <Row gutter={[16, 16]}>
            {pools.map(pool => {
              const pct = Math.round((pool.used / pool.total) * 100);
              return (
                <Col xs={24} md={12} key={pool.key}>
                  <Card
                    bordered={false}
                    style={{ borderRadius: 8, border: `1px solid ${pct > 90 ? '#ff4d4f' : pct > 70 ? '#faad14' : '#f0f0f0'}` }}
                    title={<span><ThunderboltOutlined style={{ color: '#1890ff' }} /> {pool.name}</span>}
                    extra={
                      <Space>
                        <Button size="small">扩容</Button>
                        <Button size="small">设置</Button>
                      </Space>
                    }
                  >
                    <Row gutter={16}>
                      <Col span={12}><Statistic title="归属客户" value={pool.client} valueStyle={{ fontSize: 14 }} /></Col>
                      <Col span={12}><Statistic title="绑定卡数" value={pool.cards} suffix="张" /></Col>
                    </Row>
                    <div style={{ marginTop: 12 }}>
                      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 4 }}>
                        <span style={{ fontSize: 12, color: '#666' }}>流量使用</span>
                        <span style={{ fontSize: 12, fontWeight: 600 }}>{pool.used}GB / {pool.total}GB ({pct}%)</span>
                      </div>
                      <Progress
                        percent={pct}
                        strokeColor={pct > 90 ? '#ff4d4f' : pct > 70 ? '#faad14' : '#52c41a'}
                        showInfo={false}
                      />
                      {pct > 70 && (
                        <div style={{ fontSize: 11, color: pct > 90 ? '#ff4d4f' : '#faad14', marginTop: 4 }}>
                          {pct > 90 ? '⚠️ 流量即将耗尽，请及时扩容！' : '⚡ 流量使用超过70%'}
                        </div>
                      )}
                    </div>
                  </Card>
                </Col>
              );
            })}
          </Row>
        </div>
      )
    }
  ];

  return (
    <div style={{ padding: 16 }}>
      <Card bordered={false} style={{ borderRadius: 8 }}>
        <Tabs items={items} />
      </Card>
    </div>
  );
};

export default PackagePool;
